import { DataBean } from "../../DataBean";


export class RelationshipByOwner extends DataBean {

    public async getAccountRelationshipByOwner(idOwner: any,type:any): Promise<any> {
        return this.getCustomService("OrangeBase", "java.util.List_getAccountRelationshipByOwner_Number_Number", [idOwner,type]);
    }

}